<template>
    <b-input-group prepend="Tampilkan" class="align-items-center" style="width: auto">
        <b-form-select v-model="show" @change="$emit('limit-change', show)" :options="options" />
        <span class="ml-2">{{ totalViewText }}</span>
    </b-input-group>
</template>

<script>
export default {
    name: 'page-sizer',
    props: {
        totalRows: { type: Number, required: true },
        options: { type: Array, required: true },
        page: { type: Number, required: true }
    },
    data() {
        return {

            totalViewText: "",
            show: 10

        }
    },
    methods: {

        recalculate() {

            let pg = this.page - 1

            let prev = pg * this.show + 1
            let limit = pg * this.show + this.show
            if (limit > this.totalRows) limit = this.totalRows

            this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

        }

    },
    watch: {

        totalRows(newVal) {
            this.recalculate()
        },

        options(newVal) {
            this.recalculate()
        },

        page(newVal) {
            this.recalculate()
        },

        show(newVal) {
            this.recalculate()
        }

    },
    created() {
        this.recalculate()
    }
}
</script>
